import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
//import ReactPixel from 'react-facebook-pixel';

// Setup Google Analytics
const useGoogleAnayltics = process.env.REACT_APP_GoogleAnalyticsKey !== undefined;
if (useGoogleAnayltics) {
    ReactGA.initialize(process.env.REACT_APP_GoogleAnalyticsKey);
}

// Facebook Pixel
// const useFacebookAnayltics = process.env.REACT_APP_FacebookPixelKey !== undefined;
// if (useFacebookAnayltics) {
//     //const advancedMatching = { em: 'some@email.com' };
//     const advancedMatching = { };

//     const options = {
//         autoConfig: true, 	// set pixel's autoConfig
//         debug: false, 		// enable logs
//     };

//     ReactPixel.init(process.env.REACT_APP_FacebookPixelKey, advancedMatching, options);
// }

// handles route changes
class GoogleAnalytics extends React.Component {
    constructor(props) {
        super(props);
        // Log the initial page load
        this.logPageView(this.props.history.pathname);

        // create a listener to log page views
        this.props.history.listen((location, action) => {
            this.logPageView(location.pathname);
        });
    }

    logPageView = (pathName) => {
        if (useGoogleAnayltics)
            ReactGA.pageview(pathName);
        // if (useFacebookAnayltics)
        //     ReactPixel.pageView();
    }

    render() {
        return null;
    }
}

export default withRouter(GoogleAnalytics);

// handles tab clicks
export const pageView = (pathname) => {
    if (useGoogleAnayltics)
        ReactGA.pageview(pathname);
    // if (useFacebookAnayltics)
    //     ReactPixel.pageView();
}